<script>
  import { fade } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';

  export let isOpen = false;
  export let title = 'Modal Title';

  const dispatch = createEventDispatcher();

  $: if (isOpen) {
    dispatch('open');
  } else {
    dispatch('close');
  }

  function closeModal() {
    dispatch('close');
  }
</script>

{#if isOpen}
  <div class="modal-overlay" on:click={closeModal} transition:fade={{duration: 200}}>
    <div class="modal" on:click|stopPropagation>
      <div class="modal-header">
        <h2><img src="/images/help.svg" height="26pt" style="vertical-align: text-top;filter:invert(100%);"  alt="Hjälp" title="Hjälp"/> {title}</h2>
        <button on:click={closeModal}>×</button>
      </div>
      <div class="modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 40;
  }
  
  .modal {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 700px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .modal-header {
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(20px);
    padding: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    height: 35pt;
    z-index: 1;
  }
  
  .modal-header h1 {
    margin: 0;
  }
  
  .modal-header button {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
  
  .modal-content {
    padding: 1rem;
    overflow-y: auto;
  }
</style>